import update from 'immutability-helper';
import {NewsActions} from "../actions/news.actions";

const DEFAULT_STATE = {
    fetchNews: true,
    news: []
};

export const newsReducer = (state=DEFAULT_STATE, action) => {
    switch(action.type){
        case NewsActions.FETCH:
            return update(state, {
                fetchNews: {$set: true}
            });
        case NewsActions.FETCH_SUCCESS:
            return update(state, {
                fetchNews: {$set: false},
                news: {$set: action.payload}
            });
        case NewsActions.FETCH_FAILURE:
            return update(state, {
                fetchNews: {$set: false}
            });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/news.reducer.js